'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './search-result.routes';

export class SearchResultComponent {
  constructor($stateParams, DocumentService, NewsService, CalendarEventService,
              BulletinService, ImportantNumberService, $uibModal, Auth) {
    'ngInject';
    this.searchterm = $stateParams.searchterm;

    this.found = {
      docs: [],
      news: [],
      events: [],
      bbs: []
    };

    this.eventSources = [];
    this.$uibModal = $uibModal;
    this.Auth = Auth;

    var eventSource = {
      events: []
    };

    this.eventSources.push(eventSource);

    this.uiConfig = {
      calendar: {
        timezone: 'local',
        editable: true,
        defaultView: 'listMonth',
        header: {
          left: '',
          center: '',
          right: ''
        },
        eventClick: (calendarEvent, jsEvent, view) => {

          var that = this;

          var modalInstance = this.$uibModal.open({
            animation: true,
            component: 'calendarEventDetail',
            resolve: {
              calendarEvent: function () {
                return calendarEvent;
              },
              config: function () {
                return {
                  userHasPermission: that.Auth.isAdminSync()
                  || (that.Auth.getCurrentUserSync()._id === calendarEvent.meta.creationUser)
                }
              }
            }
          });

          modalInstance.result.then(
            function (result) {

              if (result.action === 'removed') {
                that.$timeout(() => {
                  that.getData();
                }, 0);
              }

            },
            function () {
            }
          );

        }
      }
    };

    DocumentService.query(data => {

      var searchTermLowercase = this.searchterm.toLowerCase();

      this.found.docs = data.filter(doc => {
        return doc.title.toLowerCase().includes(searchTermLowercase)
            || doc.description.toLowerCase().includes(searchTermLowercase)
            || doc.type.toLowerCase().includes(searchTermLowercase);
      });

    }, err => {
      console.log('Could not query documents from server');
    });

    NewsService.query(data => {

      var searchTermLowercase = this.searchterm.toLowerCase();

      this.found.news = data.filter(news => {
        return news.title.toLowerCase().includes(searchTermLowercase)
            || news.body.toLowerCase().includes(searchTermLowercase);
      });

    }, err => {
      console.log('Could not query news from server');
    });

    CalendarEventService.query(data => {

      var searchTermLowercase = this.searchterm.toLowerCase();

      this.found.events = data.filter(event => {
        return event.title.toLowerCase().includes(searchTermLowercase)
            || event.description.toLowerCase().includes(searchTermLowercase);
      });

      this.found.events.forEach(evt => {

        var event = evt;

        if (event.isRecurring) {
          event.range = {start: event.start, end: event.recurrence.until};

          event.start = moment(event.start).format("HH:mm");

          if (event.end)
            event.end = moment(event.end).format("HH:mm");

          event.dow = event.recurrence.dayOfWeek;
          event.id = event._id;
        }

        this.eventSources[0].events.push(event);
      });

    }, err => {
      console.log('Could not query calendar events from server');
    });

    BulletinService.query(data => {

      var searchTermLowercase = this.searchterm.toLowerCase();

      this.found.bbs = data.filter(bb => {
        return bb.title.toLowerCase().includes(searchTermLowercase)
            || bb.description.toLowerCase().includes(searchTermLowercase);
      });

    }, err => {
      console.log('Could not query bulletin board posts from server');
    });

    ImportantNumberService.query(data => {

      var searchTermLowercase = this.searchterm.toLowerCase();

      this.found.misc = data.filter(misc => {
        return misc.name.toLowerCase().includes(searchTermLowercase)
          || misc.number.toLowerCase().includes(searchTermLowercase)
          || misc.category.toLowerCase().includes(searchTermLowercase);
      });

    }, err => {
      console.log('Could not query import numbers from server');
    });

  }

  getPlaintext(html) {
    return (html) ? html.replace(/<[^>]+>/gm, ' ').substr(0,120) : "";
  }
}

export default angular.module('conduuApp.searchResult', [uiRouter])
  .config(routes)
  .component('searchResult', {
    template: require('./search-result.html'),
    controller: SearchResultComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/search/result/search-result.component.js